/**
 * <s-free-shipping-mirror> — shows the live free shipping message inside the product form.
 *
 * The product form is its own partial (re-rendered on variant change), so the live free shipping
 * partial that s-cart refreshes after every cart change sits outside it, hidden. This element copies
 * that hidden source into itself on load and whenever s-cart swaps it.
 *
 * Expected DOM (templates/product.liquid):
 *   <s-free-shipping-mirror data-source="product-free-shipping">…server-rendered copy…</s-free-shipping-mirror>
 *   <s-cart id="product-free-shipping" hidden>…{% partial 'product-free-shipping' %}…</s-cart>
 */
class SFreeShippingMirror extends HTMLElement {
  connectedCallback() {
    this.source = document.getElementById(this.dataset.source);
    if (!this.source) return;
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.source, { childList: true, subtree: true, characterData: true, attributes: true });
    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  sync() {
    // Copy only the message element, never the partial markers around it.
    const box = this.source.querySelector("[data-free-shipping]");
    if (!box) return;
    const html = box.outerHTML;
    if (this.innerHTML !== html) this.innerHTML = html;
  }
}

if (!customElements.get('s-free-shipping-mirror')) {
  customElements.define('s-free-shipping-mirror', SFreeShippingMirror);
}
